const STORAGE_BASE_URL = import.meta.env.VITE_STORAGE_URL as string

export const resolveMediaUrl = (path: string): string => {
  if (path.startsWith('http')) return path
  return `${STORAGE_BASE_URL}/${path}`
}
